import { render, staticRenderFns } from "./UpdateCampaignFallbackModal.vue?vue&type=template&id=62e75e08"
import script from "./UpdateCampaignFallbackModal.vue?vue&type=script&lang=js"
export * from "./UpdateCampaignFallbackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports